import api from "./axios";

export const listMatches = (page = 1, filters = {}) => {
  const q = new URLSearchParams({ page: String(page) });
  if (filters.match_type) q.set("match_type", filters.match_type);
  if (filters.year) q.set("year", filters.year);
  if (filters.competition) q.set("competition", filters.competition);
  if (filters.search) q.set("search", filters.search);
  if (filters.ordering) q.set("ordering", filters.ordering);
  return api.get(`/api/matches/list/?${q.toString()}`);
};

export const getMatch = (id) => api.get(`/api/matches/matches/${id}/`);

export const createMatch = (payload) =>
  api.post("/api/matches/matches/", payload);

export const updateMatch = (id, payload) =>
  api.put(`/api/matches/matches/${id}/`, payload);

export const deleteMatch = (id) => api.delete(`/api/matches/matches/${id}/`);

export const updatePlayingXI = (matchId, payload) =>
  api.put(`/api/matches/matches/${matchId}/playing-xi/`, payload);

// Per-match squad — pool of N players (15-20) per team from which the
// Playing XI is picked and from which Impact / Concussion subs come.
export const getMatchSquadCRUD = (matchId) =>
  api.get(`/api/matches/matches/${matchId}/match-squad/`);
export const updateMatchSquad = (matchId, payload) =>
  api.put(`/api/matches/matches/${matchId}/match-squad/`, payload);

export const updateToss = (matchId, payload) =>
  api.post(`/api/matches/matches/${matchId}/toss/`, payload);

export const getMatchDetails = (matchId) =>
  api.get(`/api/matches/matches/${matchId}/`);

export const startMatchInnings = (matchId, payload) =>
  api.post(`/api/matches/matches/${matchId}/innings/`, payload);

// Aggregated scorecard for a match (toss + XI + innings cards + result).
export const getMatchScorecard = (matchId) =>
  api.get(`/api/matches/matches/${matchId}/scorecard/`);

// Per-innings partnership breakdown — runs, balls, per-batter contributions,
// ending event. Computed server-side from the ball stream so the SPA doesn't
// need to re-derive from FOW tuples. Same tenant scoping as scorecard.
export const getMatchPartnerships = (matchId) =>
  api.get(`/api/matches/matches/${matchId}/partnerships/`);

// 2026-06-09 — chronological auto-derived match notes (drinks break,
// rain, injuries, wickets, boundaries, innings transitions).
export const getMatchNotes = (matchId) =>
  api.get(`/api/matches/matches/${matchId}/match-notes/`);

// AI-generated narrative summary
export const getMatchAIReport      = (matchId) => api.get(`/api/matches/matches/${matchId}/ai-report/`);
export const generateMatchAIReport = (matchId) => api.post(`/api/matches/matches/${matchId}/ai-report/`);

// AI tagger — fills missing analytics on past balls (Haiku, text-only).
export const aiTagMatch = (matchId, opts = {}) => {
  const q = new URLSearchParams();
  if (opts.fill_missing_only !== undefined)
    q.set("fill_missing_only", String(opts.fill_missing_only));
  if (opts.max) q.set("max", String(opts.max));
  return api.post(`/api/matches/${matchId}/ai-tag-balls/${q.toString() ? "?" + q : ""}`);
};

// AI-suggest — legacy chip-fill endpoint (still mounted at /ai-coding/suggest/).
// Kept exported for any caller that hasn't migrated to AI Score yet.
export const aiSuggestBall = (payload) =>
  api.post(`/api/matches/ai-coding/suggest/`, payload);

// AI Score — per-ball OUTCOME inference (runs / extras / wicket) from
// 8 video frames. Replaces the "AI Suggest" chip-fill button in the
// BBP coding screen per 2026-06-05 founder ask. Costs 2 ZC.
export const aiScoreBall = (payload) =>
  api.post(`/api/matches/ai-score/`, payload);